import { jsx as h } from "react/jsx-runtime";
import { createContext as p, useRef as O, useEffect as b, useMemo as v } from "react";
import { u as S } from "../useSubscriptionHandler-D4p0pO3P.js";
import { S as f } from "../signalrHub-BGmnuXQk.js";
const g = p(void 0);
function x({ children: m, agentHubUrl: a, token: o, signalRConnectionEventHandlers: i = {} }) {
  const { subscribe: c, unsubscribe: d, dispatch: t } = S(), u = O(i);
  Object.entries(i).forEach(([r, n]) => Object.assign(u.current, { [r]: n })), b(
    () => {
      const r = [
        { name: "GetState", handler: (e) => t("GetState", e) },
        { name: "OnPrimaryStatusChanged", handler: (e) => t("OnPrimaryStatusChanged", e) },
        { name: "OnWorkItemClosed", handler: (e) => t("OnWorkItemClosed", e) },
        { name: "StateTransitionRequested", handler: (e) => t("StateTransitionRequested", e) },
        { name: "OnScriptProcessCompleted", handler: (e) => t("OnScriptProcessCompleted", e) },
        { name: "OnError", handler: (e) => t("OnError", e) },
        { name: "OnBusinessUnitsChanged", handler: (e) => t("OnBusinessUnitsChanged", e) }
      ];
      let n;
      const s = new f(a, o, r, u.current);
      return s.start().then(() => n = setInterval(() => void s.send("HeartBeat"), 30 * 1e3)).catch((e) => console.error("Error starting AgentHub signalR connection.", e)), () => {
        s.stop(), clearInterval(n);
      };
    },
    [a, t, o]
  );
  const l = v(
    () => ({ subscribe: c, unsubscribe: d }),
    [c, d]
  );
  return /* @__PURE__ */ h(g.Provider, { value: l, children: m });
}
export {
  g as AgentHubEventsContext,
  x as AgentHubEventsProvider
};
//# sourceMappingURL=index.js.map
